import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { fetch as axios } from '../../axios_config';

import { handleRejectedResponse } from './utils';

export const GetTileStats = createAsyncThunk(
  'packing-stats/tile-stats',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/packing-stats/tile-stats`,
        {
          params: { currentDate: dayjs().format('YYYY-MM-DD') }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Tile Stats', rejectWithValue);
    }
  }
);

export const GetGraphStats = createAsyncThunk(
  'packing-stats/graph-stats',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/packing-stats/graph-stats`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Graph Stats', rejectWithValue);
    }
  }
);

const packingStats = createSlice({
  name: 'packingStats',
  initialState: {
    fetchingTileStats: false,
    tileStats: {},
    fetchingGraphStats: false,
    graphStats: {},
  },
  reducers: {
  },
  extraReducers: {
    [GetTileStats.pending]: (state) => {
      state.fetchingTileStats = true;
    },
    [GetTileStats.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.tileStats = data;
      state.fetchingTileStats = false;
    },
    [GetTileStats.rejected]: (state) => {
      state.fetchingTileStats = false;
    },

    [GetGraphStats.pending]: (state) => {
      state.fetchingGraphStats = true;
    },
    [GetGraphStats.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.graphStats = data;
      state.fetchingGraphStats = false;
    },
    [GetGraphStats.rejected]: (state) => {
      state.fetchingGraphStats = false;
    },
  },
});

const { reducer, actions } = packingStats;

export const { } = actions;

export default reducer;
